import React from 'react'

export default function SingleFrameLayout({children, narrow}) {
  return  <div className='layout-main-frame'>
            <div className={`layout-content ${narrow ? 'narrow' : ''}`}>
              { children }
            </div>
          </div>
}
